import React, { useState } from 'react';
import { CreateFlowModal } from './CreateFlowModal';
import { CreateTypeSelector } from './shared/CreateTypeSelector';
import { ManualCreateCourseModal } from './ManualCreateCourseModal';
import { SmartCreateCourseModal } from './SmartCreateCourseModal';
import { ModalContent } from './shared/FormComponents';
import { CreateFlowBackButton } from './shared/CreateFlowBackButton';
import styled from 'styled-components';

interface IProps {
  onClose: () => void;
  onBack: () => void;
}

type CourseCreationStep = 'selection' | 'manual' | 'smart';

export const CreateCourseModal = (props: IProps) => {
  const { onClose, onBack } = props;
  const [currentStep, setCurrentStep] = useState<CourseCreationStep>('selection');

  const handleManualCreateClick = () => {
    setCurrentStep('manual');
  };

  const handleSmartCreateClick = () => {
    setCurrentStep('smart');
  };

  const handleBackToSelection = () => {
    setCurrentStep('selection');
  };

  if (currentStep === 'manual') {
    return <ManualCreateCourseModal onClose={onClose} onBack={handleBackToSelection} />;
  }

  if (currentStep === 'smart') {
    return <SmartCreateCourseModal onClose={onClose} onBack={handleBackToSelection} />;
  }

  return (
    <CreateFlowModal title="Create Course" onClose={onClose}>
      <ModalContent>
        <BackButtonContainer>
          <CreateFlowBackButton onClick={onBack} />
        </BackButtonContainer>
        <CreateTypeSelector onManualCreateClick={handleManualCreateClick} onSmartCreateClick={handleSmartCreateClick} />
      </ModalContent>
    </CreateFlowModal>
  );
};

const BackButtonContainer = styled.div`
  margin-bottom: 0;
  
  button {
    margin-bottom: 0 !important;
  }
`;
